// extracted by css-extract-rspack-plugin
export default {"jumpToBottom":"JumpToBottom-module__jumpToBottom__NEDVO"};